import { Navigate } from "react-router-dom";
import Constant from "../util/constant";

/**
 * Renders children only for CLUB_MANAGER; employees (and others) redirect to POS home.
 */
const ClubManagerOnly = ({ children }) => {
  if (window.localStorage.getItem("role") !== Constant.ROLES.CLUB_MANAGER) {
    return <Navigate to="/club-offline-sale" replace />;
  }
  return children;
};

export default ClubManagerOnly;
